import React from 'react'
import styles from './styles.module.scss'

/** Toda children com a tag "aside" terá o efeito de loading. */
export default function BaseLoading({ children }: { children: React.ReactNode }) {
    return (
        <div className={styles.container}>
            {children}
        </div>
    )
}
